module.exports = __webpack_public_path__ + "img/hp-h3.f3f20c25.svg";